<template>
  <div
    class="context-menu--wrap fixed outline-none z-[9999] cursor-pointer"
    :class="{ 'origin-top-right': isRTL, 'origin-top-left': !isRTL }"
    :style="style"
    tabindex="0"
    @keydown.esc="$emit('close')"
    @focusout="onFocusOut"
  >
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      left: this.x,
      top: this.y,
      show: false,
      // Read once, before the first render, so the menu never paints on the wrong
      // side and then jumps. App.vue is what puts the app into RTL.
      isRTL:
        document.dir === 'rtl' || !!document.querySelector('.app-rtl--wrapper'),
    };
  },
  computed: {
    // The pointer coordinate is a viewport x. In Arabic the menu opens towards the
    // start of the line, which means anchoring its *end* edge to that coordinate —
    // otherwise it unfurls off the edge of the screen.
    style() {
      if (this.isRTL) {
        return {
          top: this.top + 'px',
          right: window.innerWidth - this.left + 'px',
        };
      }
      return {
        top: this.top + 'px',
        left: this.left + 'px',
      };
    },
  },
  mounted() {
    this.$nextTick(() => this.$el.focus());
  },
  methods: {
    // `blur` fires the moment focus moves to a menu item inside, which used to
    // close the menu before it could be used with a keyboard. `focusout` bubbles,
    // so we can ask whether focus actually left the menu.
    onFocusOut(event) {
      if (!this.$el.contains(event.relatedTarget)) {
        this.$emit('close');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// The menu grows out of the point that was clicked, quickly. Anything slower than
// this reads as lag on a right-click.
.context-menu--wrap {
  animation: context-menu-in 110ms cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes context-menu-in {
  from {
    opacity: 0;
    transform: scale(0.96);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .context-menu--wrap {
    animation: none;
  }
}
</style>
